import { Action } from "@ngrx/store";

import { DIALOG_STATUS_ACTION_TYPE } from "./dialog-status.action";
import { DialogStatusState } from "./dialog-status.model";

const initialState: DialogStatusState = {
	counter: 0,
};

export function dialogStatusReducer(state = initialState, action: Action): DialogStatusState {
	switch (action.type) {
		case DIALOG_STATUS_ACTION_TYPE.open: {
			return {
				...state,
				counter: state.counter + 1,
			};
		}
		case DIALOG_STATUS_ACTION_TYPE.close: {
			return {
				...state,
				counter: state.counter > 0 ? state.counter - 1 : 0,
			};
		}
		default:
			return state;
	}
}
